import React from 'react';
import { View, Text, TouchableOpacity, ScrollView, StyleSheet } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';
import { Ionicons as Icon } from '@expo/vector-icons';
import { Colors } from '../constants/colors';

var NOTIFS = [
  { id: '1', icon: '🎁', text: 'You earned a $10 Tim Hortons gift card!', time: '2h ago' },
  { id: '2', icon: '🔥', text: '4-day streak! Keep it going!', time: '6h ago' },
  { id: '3', icon: '✅', text: 'Quest completed: Take medications', time: '8h ago' },
  { id: '4', icon: '💬', text: 'NewDawn42 reacted to your post', time: '1d ago' },
  { id: '5', icon: '🏆', text: 'Halfway to Milestone 1!', time: '2d ago' },
  { id: '6', icon: '👋', text: 'Welcome to Momentum!', time: '5d ago' },
];

export default function NotificationsScreen({ navigation }) {
  return (
    <View style={s.container}>
      <SafeAreaView style={s.safe}>
        <View style={s.header}>
          <TouchableOpacity onPress={function() { navigation.goBack(); }}>
            <Icon name="chevron-back" size={24} color={Colors.primary} />
          </TouchableOpacity>
          <Text style={s.title}>Notifications</Text>
          <View style={{ width: 24 }} />
        </View>
        <ScrollView contentContainerStyle={s.content}>
          {NOTIFS.map(function(n) {
            return (
              <View key={n.id} style={s.notifRow}>
                <Text style={s.notifIcon}>{n.icon}</Text>
                <View style={s.notifContent}>
                  <Text style={s.notifText}>{n.text}</Text>
                  <Text style={s.notifTime}>{n.time}</Text>
                </View>
              </View>
            );
          })}
        </ScrollView>
      </SafeAreaView>
    </View>
  );
}

var s = StyleSheet.create({
  container: { flex: 1, backgroundColor: Colors.bgTop },
  safe: { flex: 1 },
  header: { flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', paddingHorizontal: 16, paddingVertical: 12 },
  title: { fontSize: 20, fontWeight: '700', color: Colors.textDark },
  content: { padding: 20 },
  notifRow: { flexDirection: 'row', alignItems: 'flex-start', gap: 12, padding: 14, backgroundColor: Colors.card, borderRadius: 14, marginBottom: 8 },
  notifIcon: { fontSize: 24 },
  notifContent: { flex: 1 },
  notifText: { fontSize: 14, color: Colors.textDark, lineHeight: 20 },
  notifTime: { fontSize: 11, color: Colors.textLight, marginTop: 4 },
});
